export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://api.factory-247.com/v1';

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  USER: 'user',
} as const;

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  QR_LOGIN: '/qr-login',
  SCHEDULE: '/schedule',
  EQUIPMENT: '/equipment',
  PRODUCTS: '/products',
  METRICS: '/metrics',
  ADMIN_USERS: '/admin/users',
  ADMIN_CONFIG: '/admin/config',
} as const;

export const ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  WORKER: 'worker',
} as const;

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [5, 10, 25, 50],
} as const;

export const PROTEIN_COLORS: Record<string, [number, number, number]> = {
  'BEEF':         [165,   0,  38],
  'PORK':         [215,  48,  39],
  'LAMB':         [244, 109,  67],
  'DUCK':         [253, 174,  97],
  'TURKEY':       [254, 224, 144],
  'CHICKEN':      [224, 243, 248],
  'SALMON':       [171, 217, 233],
  'COD':          [116, 173, 209],
  'SWEET POTATO': [ 69, 117, 180],
};

// Width in pixels of one oven column slot — used in schedule grid, lane layout, and RecipeBlock
export const SLOT_WIDTH = 80;

export const SCHEDULE_CONFIG = {
  START_HOUR: 0,
  START_MINUTE: 0,
  END_HOUR: 24,
  END_MINUTE: 0,
  INTERVAL_MINUTES: 10,
  ALTERNATE_ROW_COUNT: 3, // Number of rows before alternating color
  DAYS_TO_SHOW: 7,        // Number of days to show in continuous scroll
} as const;
